import userJson from "./User.json";
import homeJson from "./Home.json";
import productJson from "./Product.json";

import { forEach, mapKeys } from 'lodash'
import { sourceKey } from '../config'

const objectsToRemap = [
    {
        value: userJson,
        key: sourceKey.user,
    },
    {
        value: homeJson,
        key: sourceKey.home,
    },
    {
        value: productJson,
        key: sourceKey.product,
    },
]

let remappedObjects = {}
forEach(objectsToRemap, (item) => {
    let newObj = item.value;
    if (item.key) {
        newObj = mapKeys(item.value, (value, key) => {
            return `${item.key}.${key}`
        })
    }

    remappedObjects = {
        ...remappedObjects,
        ...newObj
    }
})


const allPtJson = {
    ...remappedObjects
}

export default allPtJson